import { extendTailwindMerge } from "tailwind-merge";

// Teach tailwind-merge the non-default KEDO scales so conflicting custom
// utilities collapse correctly (font-size adds 2xs; border-radius adds the
// KEDO ramp). Spacing/colour groups use prefixes tailwind-merge already
// classifies, so they need no override.
const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            "font-size": [{ text: ["2xs", "xs", "sm", "base", "lg", "xl", "2xl", "3xl", "4xl", "5xl", "6xl", "7xl"] }],
            rounded: [{ rounded: ["xs", "sm", "md", "lg", "xl", "2xl", "3xl"] }],
        },
    },
});

export default function cn(...classes) {
    return twMerge(classes.filter(Boolean).join(" "));
}
